import {DPACarouselCreativeNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, ServerNode} from 'common/src/modules/nodes/nodes.types';
import {serializeSocialCarouselNode} from 'common/src/modules/campaigns/utils/serializeSocialCarouselNode';

export function serializeFacebookDPACarouselCreative(node: DTNode, newNode: ServerNode) {
  const carouselNode = node as DPACarouselCreativeNode;

  const serializedCarouselNode = serializeSocialCarouselNode(node, newNode);

  return {
    ...serializedCarouselNode,
    catalogId: carouselNode.catalogId ? carouselNode.catalogId : '',
    productSetId: carouselNode.productSetId ? carouselNode.productSetId : '',
    isMultipleProducts: carouselNode.isMultipleProducts,
    additionalImageIndex: carouselNode.additionalImageIndex,
    utmParams: carouselNode.utmParams,
    type: NodeType.FACEBOOK_DPA_CAROUSEL_CREATIVE,
    externalAdDescription: carouselNode.externalAdDescription,
    externalAdHeadline: carouselNode.externalAdHeadline,
    externalAdCTA: carouselNode.externalAdCTA,
    externalAdPrimaryText: carouselNode.externalAdPrimaryText,
    landingPageSource: carouselNode.landingPageSource,
    landingPage: carouselNode.landingPage,
    displayCarouselCardsAsSlideshow: carouselNode.displayCarouselCardsAsSlideshow,
    addPageProfileCard: carouselNode.addPageProfileCard,
    previewItemUrls: carouselNode.previewItemUrls,
    displayUrl: carouselNode.displayUrl || '',
    trackingPixels: carouselNode.trackingPixels,
  };
}

